import React from 'react';
import { Link } from 'react-router-dom';
import { Users, UserPlus, ArrowRight } from 'lucide-react';

const InviteCard = ({ invitesSent = 0, invitesJoined = 0 }) => {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-5">
      <div className="flex items-center gap-2 mb-4">
        <Users className="w-4 h-4 text-violet-600" />
        <h3 className="text-sm font-semibold text-gray-800">Invite & Grow</h3>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-4">
        <div className="rounded-lg bg-violet-50 p-3 text-center">
          <p className="text-2xl font-bold text-violet-700">{invitesSent}</p>
          <p className="text-xs text-violet-500 mt-0.5">Invites Sent</p>
        </div>
        <div className="rounded-lg bg-emerald-50 p-3 text-center">
          <p className="text-2xl font-bold text-emerald-700">{invitesJoined}</p>
          <p className="text-xs text-emerald-500 mt-0.5">Joined</p>
        </div>
      </div>

      <Link
        to="/admin/invite"
        className="flex items-center justify-center gap-2 w-full text-sm font-medium text-white bg-violet-600 hover:bg-violet-700 rounded-lg px-4 py-2.5 transition"
      >
        <UserPlus className="w-4 h-4" />
        Invite More People
        <ArrowRight className="w-3 h-3" />
      </Link>
    </div>
  );
};

export default InviteCard;
